module.exports = firebaseui;